import { ImportStatusResponse } from '@epi-models/pages/MassUpload';
import { ApiConstants } from '@epi-constants/actions';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

const logoutSuccess = createAction(`${ApiConstants.LOGOUT_ACTION}_SUCCESS`);

type BeneficiariesImportState = {
  lastImportRequestId: number | null;
  importStatus: ImportStatusResponse | null;
  leaveConfirmationRequested: boolean;
};

const initialState: BeneficiariesImportState = {
  lastImportRequestId: null,
  importStatus: null,
  leaveConfirmationRequested: false
};

const beneficiariesImportSlice = createSlice({
  name: 'beneficiariesImport',
  initialState,
  reducers: {
    setImportStatus: (
      state,
      { payload }: PayloadAction<ImportStatusResponse>
    ) => {
      state.importStatus = payload;
    },
    requestLeaveConfirmation: state => {
      state.leaveConfirmationRequested = true;
    },
    clearLeaveConfirmationRequest: state => {
      state.leaveConfirmationRequested = false;
    }
  },
  extraReducers: builder => {
    builder.addCase(logoutSuccess, () => initialState);
  }
});

export const { reducer, actions: beneficiariesImportActions } =
  beneficiariesImportSlice;
